// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"679a8a57","156":"134c441d","307":"ebc38079","336":"839e1f11","425":"14d01ff9","444":"72e5dd5e","607":"8306bc91","806":"26c92e0e","810":"36f24893","828":"3d3da71e","861":"23428464","925":"34fd0974"}[chunkId] + ".chunk.js";
};